export class SpheeresLink {}